import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "./router";
import { preloadBadgeImages } from "./config/badges";
import "./styles.css";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const SUPABASE_KEY = (import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) as string | undefined;

const rootEl = document.getElementById("root")!;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  rootEl.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;font-family:system-ui,-apple-system,sans-serif;background:#0b0b10;color:#f5f5f7">
      <div style="max-width:560px;background:#15151c;border:1px solid #2a2a35;border-radius:14px;padding:28px;line-height:1.5">
        <h1 style="margin:0 0 12px;font-size:20px">Configuration required</h1>
        <p style="margin:0 0 16px;color:#c7c7d1">
          The app can't start because Supabase environment variables are missing.
        </p>
        <p style="margin:0 0 8px;color:#c7c7d1">Please set these in your hosting environment:</p>
        <ul style="margin:0 0 16px 18px;color:#c7c7d1">
          <li><code style="background:#222231;padding:2px 6px;border-radius:4px">VITE_SUPABASE_URL</code></li>
          <li><code style="background:#222231;padding:2px 6px;border-radius:4px">VITE_SUPABASE_ANON_KEY</code></li>
        </ul>
        <p style="margin:0;color:#8a8a96;font-size:13px">
          On Cloudflare Pages: Project &rarr; Settings &rarr; Environment variables (Production &amp; Preview).
          Redeploy after saving. These must be set at <strong>build time</strong> because Vite inlines them into the bundle.
        </p>
      </div>
    </div>
  `;
  // eslint-disable-next-line no-console
  console.error(
    "[startup] Missing VITE_SUPABASE_URL and/or VITE_SUPABASE_ANON_KEY"
  );
} else {
  const router = getRouter();
  createRoot(rootEl).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
  // Warm the cache for all badge images so Profile / Notifications render instantly.
  preloadBadgeImages();
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
